class QuickAdd extends HTMLElement {
    static forms = {};

    constructor() {
        super();
    }

    connectedCallback() {
        this.handle = this.dataset.handle;
        this.updateQuery();

        this.addEventListener("click", this.handleEvent.bind(this));
        this.addEventListener("keydown", this.handleEvent.bind(this));
    }

    handleEvent(event) {
        if (event.type === "keydown" && event.key !== "Enter") return;
        event.preventDefault();
        this.setAttribute("data-loading", true);

        this.updateQuery();

        if (this.dataset.form === "true") {
            this.showForm().finally(() => this.setAttribute("data-loading", false));
        } else {
            this.addToCart().finally(() => this.setAttribute("data-loading", false));
        }
    }

    updateQuery() {
        this.query = `?section_id=product--quick-add--form&variant=${this.dataset.id}`;
    }

    async showForm() {
        // Fetch form HTML only if it has not been fetched before for this handle
        if (!QuickAdd.forms[this.handle] || QuickAdd.forms[this.handle].dataset.variant !== this.dataset.id) {
            try {
                const response = await fetch(`${theme.urls.root}/products/${this.handle}/` + this.query);
                if (!response.ok) throw new Error(response.status);

                const text = await response.text();
                const formHtml = theme.utils.parseHtml(text, ".product--quick-add--form");
                
                // Update or replace existing form
                if (QuickAdd.forms[this.handle]) {
                    QuickAdd.forms[this.handle].remove();
                }
                QuickAdd.forms[this.handle] = formHtml;
                const container = theme.drawer.querySelector('[data-view="product-form"]');
                container.innerHTML = '';
                container.appendChild(formHtml);

                theme.utils.updateRecentProducts(this.handle);
                theme.drawer.open("right", "product-form", this);
            } catch (error) {
                console.error('Error fetching or updating QuickAdd form:', error);
            }
        } else {
            theme.drawer.open("right", "product-form", this);
        }
    }

    async addToCart() {
        const quantity = theme.utils.getQuantity(this.dataset.id, this.dataset, 1);
        if (quantity) {
            try {
                const response = await fetch(theme.urls.cart, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ items: [{ id: this.dataset.id, quantity }] })
                });
                if (!response.ok) throw new Error(response.status);

                theme.drawer.open("right", "cart-drawer", this);
            } catch (error) {
                console.error('Error adding item to cart:', error);
            }
        }
    }

    static clearFormListeners() {
        window.addEventListener("theme:navigation:reloaded", QuickAdd.clearForms);
        window.addEventListener("theme:search:reloaded", QuickAdd.clearForms);
    }

    static clearForms() {
        Object.keys(QuickAdd.forms).forEach(key => QuickAdd.forms[key].remove());
        QuickAdd.forms = {};
    }
}

QuickAdd.clearFormListeners();
customElements.define("product-quick-add", QuickAdd);
